import {loadGoogleRecaptcha} from '@/resource/js';

const siteKey = '6LetKzkeAAAAADlKr2DM3MYTQK7JwdGvI5_yC1_N';

export async function createGoogleCaptcha() {
  const type = 'recaptcha';
  await loadGoogleRecaptcha(siteKey);
  await new Promise((resolve) => window.grecaptcha.enterprise.ready(() => resolve()));
  return {
    type,
    show(action) {
      return new Promise((resolve) => {
        window.grecaptcha.enterprise
          .execute(siteKey, {action})
          .then((recaptchaToken) => resolve({recaptchaToken, recaptchaVersion: 1}))
          .catch((e) => console.warn('show google captcha error', e));
      });
    },
  };
}
